export default {
  title: "Registration to an event",
  subtitle: "Subtitle",
  fileUploader: {
    message: "Drop your file(s) here, or click to select them.",
    invalidExtension: ({ named }) => `The file "${named('name')}" does not have a valid extension.`,
    multipleDisabled: "Only one file can be uploaded at a time.",
    nDocumentRequired: ({ named }) => `At least ${named('minRequired')} documents are required`,
    documentRequired: "Document is required.",
  },
}